/* eslint-disable indent,no-new,no-undef */
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import VueRouter from 'vue-router'
import Vue from 'vue'
import VueGtm from 'vue-gtm'
import VueMeta from 'vue-meta'
import WriteReview from '@/pages/reviews/WriteReview'
import Resources from '@/pages/Resources'
import ContactUs from '@/pages/Contact'
import Unsubscribed from '@/pages/Unsubscribed'
import FAQs from '@/pages/Faq'
import SocialRedirect from '@/pages/SocialRedirect'
import ReviewThankYou from '@/pages/reviews/Thanks'
import ActivateAccount from '@/pages/ActivateAccount'
import UpdatePassword from '@/pages/UpdatePassword'
import CreatePassword from '@/pages/CreatePassword'
import NotFound from '@/pages/NotFound'
import SearchResults from '@/pages/SearchResults'
import Legal from '@/pages/legal/Legal'
import Privacy from '@/pages/legal/Privacy'
import BusinessReviewsList from '@/pages/business/BusinessReviewsList'
import WriteAnEmailReview from '@/pages/reviews/WriteAnEmailReview'
import FacebookReview from '@/pages/business/FacebookReview'

import {AuthLayout, DefaultLayout} from '@/layouts'
import {Login, Register, ForgotPassword, VerifyPhone} from '@/pages/auth'
import {UserProfile, UpdatePhonePage} from '@/pages/user'
import {IndustryList, IndustryDetail, SubIndustryDetail} from '@/pages/industries'
import {BusinessDetail} from '@/pages/business'
import {ReviewDetail} from '@/pages/reviews'
import {Mip, Home} from '@/pages'

Vue.use(VueRouter)

const routes = [
  {
    path: '/mip',
    name: 'Mip',
    component: Mip
  },
  {
    path: '',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: '/write-a-review/:slug?',
        name: 'WriteReview',
        props: true,
        component: WriteReview,
        meta: {requiresLogin: true}
      },
      {
        path: '/contact-us',
        name: 'Contact us',
        component: ContactUs
      },
      {
        path: '/unsub',
        name: 'Unsubscribed',
        component: Unsubscribed
      }
    ]
  },
  {
    path: '',
    component: AuthLayout,
    children: [
      {
        path: '/profile/update-phone',
        name: 'UpdatePhonePage',
        component: UpdatePhonePage,
        meta: {requiresLogin: true}
      },
      {
        path: '/login',
        name: 'Login',
        component: Login
      },
      {
        path: '/register',
        name: 'Register',
        component: Register
      },
      {
        path: '/forgot-password',
        name: 'Forgot Password',
        component: ForgotPassword
      },
      {
        path: '/verify-phone/:token',
        name: 'Verify Phone',
        props: true,
        component: VerifyPhone
      }
    ]
  },
  {
    path: '/update-password/:token',
    name: 'Update Password',
    props: true,
    component: UpdatePassword
  },
  {
    path: '/create-password/:token',
    name: 'Create Password',
    props: true,
    component: CreatePassword
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '/resources',
    name: 'Resources',
    component: Resources
  },
  {
    path: '/faq',
    name: 'Frequently Asked Questions',
    component: FAQs
  },
  {
    path: '/secret-page',
    component: SocialRedirect
  },
  {
    path: '/secret-page/facebook',
    component: SocialRedirect
  },
  {
    path: '/thank-you',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'ThankYou',
        component: ReviewThankYou
      }
    ]
  },
  {
    path: '/industries',
    component: DefaultLayout,
    children: [
      {
        path: '',
        props: true,
        name: 'IndustryLanding',
        component: IndustryList
      },
      {
        path: ':slug',
        props: true,
        name: 'Industries-Category',
        component: IndustryDetail
      },
      {
        path: ':indSlug/:subIndSlug',
        props: true,
        name: 'SubIndustriesDetail',
        component: SubIndustryDetail
      }
    ]
  },
  {
    path: '/activate',
    name: 'Activate Account',
    component: ActivateAccount
  },
  {
    path: '/write-an-email-review/:slug?',
    name: 'Write An Email Review',
    props: true,
    component: WriteAnEmailReview,
    meta: {requiresLogin: true}
  },
  {
    path: '/profile',
    name: 'Profile',
    component: DefaultLayout,
    children: [
      {
        path: ':uuid',
        name: 'UserProfile',
        component: UserProfile,
        props: true
      }
    ]
  },
  {
    path: '/search-results',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'SearchResult',
        component: SearchResults
      }
    ]
  },
  {
    path: '/legal',
    component: DefaultLayout,
    children: [
      {
        path: 'legal',
        name: 'Legal',
        component: Legal
      },
      {
        path: 'privacy',
        name: 'Privacy Policy',
        component: Privacy
      }
    ]
  },
  {
    path: '/:business',
    component: DefaultLayout,
    children: [
      {
        props: true,
        path: '/:business',
        component: BusinessDetail,
        name: 'BusinessDetail'
      },
      {
        props: true,
        path: 'reviews/:permalink',
        name: 'Reviewdetail',
        component: ReviewDetail
      }
    ]
  },
  {
    path: '/reviews-list/:slug',
    name: 'Review List',
    component: BusinessReviewsList,
    props: true
  },
  {
    path: '/facebook-review/:slug',
    name: 'Facebook Review',
    component: FacebookReview,
    props: true
  }
]

Vue.use(VueMeta)

Vue.use(VueGtm, {
  id: 'GTM-56F63S7', // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false // Whether or not display console logs debugs (optional)
})

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  if (process.env.MAINTENANCE_MODE === 'true') {
    if (to.name === 'Mip') {
      next()
    } else {
      next({
        name: 'Mip'
      })
    }
  }

  window.pageTracked = false
  window.events.$emit('mobileNavMenuSelected')
  window.scrollTo(0, 0)
  if (window.googletag) {
    window.googletag.cmd.push(() => {
      window.googletag.destroySlots()
    })
  }
  // check whether Auth required as well check for other query params required to redirect back to respective page after successfull login
  if (to.matched.some(record => record.meta.requiresAuth) || (to.matched.some(record => record.meta.requiresLogin) && ((to.query.hasOwnProperty('source') && to.query.hasOwnProperty('r')) || !to.query.hasOwnProperty('source')))) {
    const isLoggedIn = !!localStorage.auth_token
    const expiredToken = (token) => {
      if (token === null) {
        return true
      }
      let decodedToken = jwtDecode(token)
      let now = Date.now() / 1000
      return decodedToken.exp < Number(now.toFixed(0))
    }
    const authToken = (typeof localStorage.auth_token !== 'undefined' && localStorage.auth_token !== null) ? localStorage.auth_token : null

    if (!isLoggedIn || expiredToken(authToken)) {
      if (expiredToken(authToken)) {
        const twentykCamp = localStorage.getItem('twentykCamp')
        localStorage.clear()
        if (twentykCamp) {
          localStorage.setItem('twentykCamp', twentykCamp)
        }
      }
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    } else {
      next()
    }
  } else {
    next()
  }
  axios.post('/consumer-tracking/page-view', {url: to.fullPath})
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js